import api from './api';

// Protocol API service functions
export const protocolService = {
  // Get all protocols
  async getProtocols(params = {}) {
    try {
      // Always include questions count
      const query = new URLSearchParams({ include_questions_count: 'true', ...params }).toString();
      const response = await api.get(`/protocols?${query}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching protocols:', error);
      throw error;
    }
  },

  // Get protocols excluding those with answered questions (for linking operations)
  async getProtocolsForLinking(params = {}) {
    try {
      console.log('Fetching protocols for linking (excluding answered protocols)');
      const query = new URLSearchParams({
        include_questions_count: 'true',
        exclude_answered: 'true',
        ...params
      }).toString();
      const response = await api.get(`/protocols?${query}`);
      console.log(`Found ${response.data.protocols?.length || 0} linkable protocols`);
      return response.data;
    } catch (error) {
      console.error('Error fetching protocols for linking:', error);
      throw error;
    }
  },

  // Get a single protocol by ID
  async getProtocol(id, includeQuestions = false) {
    try {
      const response = await api.get(`/protocols/${id}${includeQuestions ? '?include_questions=true' : ''}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching protocol ${id}:`, error);
      throw error;
    }
  },

  // Create a new protocol
  async createProtocol(protocolData) {
    try {
      const response = await api.post('/protocols', protocolData);
      return response.data;
    } catch (error) {
      console.error('Error creating protocol:', error);
      throw error;
    }
  },

  // Update an existing protocol
  async updateProtocol(id, protocolData) {
    try {
      const response = await api.put(`/protocols/${id}`, protocolData);
      return response.data;
    } catch (error) {
      console.error(`Error updating protocol ${id}:`, error);
      throw error;
    }
  },

  // Delete a protocol
  async deleteProtocol(id) {
    try {
      const response = await api.delete(`/protocols/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting protocol ${id}:`, error);
      throw error;
    }
  },

  // Link questions to a protocol
  async linkQuestions(protocolId, questionIds) {
    try {
      const response = await api.post(`/protocols/${protocolId}/questions`, { question_ids: questionIds });
      return response.data;
    } catch (error) {
      console.error(`Error linking questions to protocol ${protocolId}:`, error);
      throw error;
    }
  },

  // Unlink questions from a protocol
  async unlinkQuestions(protocolId, questionIds) {
    try {
      const response = await api.delete(`/protocols/${protocolId}/questions`, { data: { question_ids: questionIds } });
      return response.data;
    } catch (error) {
      console.error(`Error unlinking questions from protocol ${protocolId}:`, error);
      throw error;
    }
  },

  // Unlink a single question from a protocol
  async unlinkQuestionFromProtocol(protocolId, questionId) {
    try {
      const response = await api.delete(`/protocols/${protocolId}/questions/${questionId}`);
      if (!response.data.success && response.data.error) {
        throw new Error(response.data.error);
      }
      return response.data;
    } catch (error) {
      console.error(`Error unlinking question ${questionId} from protocol ${protocolId}:`, error);
      // Rethrow with more descriptive message
      throw new Error(error.response?.data?.message || error.message);
    }
  }
};